
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 64 64","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"m51.4 28-7.2-8.4H13.8c-2.3 0-4.1 1.8-4.1 4.1v14.7h4.1c0 3.4 2.8 6.2 6.2 6.2s6.2-2.8 6.2-6.2h12.4c0 3.4 2.8 6.2 6.2 6.2 3.4 0 6.2-2.8 6.2-6.2h4.1v-6.7c0-2-1.7-3.7-3.7-3.7zm-34.6.1H11V24c0-1.5 1.2-2.8 2.8-2.8h3v6.9zm3.3 13.4c-1.9 0-3.4-1.7-3.1-3.7.2-1.3 1.2-2.3 2.5-2.5 2-.3 3.7 1.2 3.7 3.1 0 1.7-1.4 3.1-3.1 3.1zm-1.7-13.4v-6.9h7.8v6.9h-7.8zm16.8 0h-7.4v-6.9h7.4v6.9zM45 41.5c-1.9 0-3.4-1.7-3.1-3.7.2-1.3 1.2-2.3 2.5-2.5 2-.3 3.7 1.2 3.7 3.1 0 1.7-1.4 3.1-3.1 3.1zm-8.2-13.4v-6.9h6.1l5.7 6.9H36.8z"}})])
          )
        }
      }
    